import React, { useState, useEffect } from 'react';
import { XGrid } from '@material-ui/x-grid';
import QuickSearch from '../QuickSearch';
import { searchPlaces } from 'reducers/SearchReducer';

let lastSearchTerm = '';

function SelectTarget(props) {
  const { columns, setSourceID, targetID } = props;
  const [rawRows, setRawRows] = useState([]);
  const [selectedIDs, setSelectedIDs] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [loaded, setLoaded] = useState(true);
  const [ViewDeleted] = useState(false);
  const limit = 1000;
  const [targetPlace, setTargetPlace] = useState(null);

  useEffect(() => {
    const r = props.rows.filter((x) => x.id !== targetID && !x.IsDeleted);
    setTargetPlace(props.rows.find((x) => x.id === targetID));
    setRawRows(r);
  }, []);

  const search = async (text = lastSearchTerm, offset = 0) => {
    lastSearchTerm = text;
    if (!text || text.length < 3) return;
    setLoaded(false);
    searchPlaces(text, ViewDeleted, offset, limit)
      .then((result) => {
        const r = result.filter((x) => x.ptsPlaceID !== targetPlace.ptsPlaceID && !x.IsDeleted);
        setRawRows(r);
      })
      .finally(() => setLoaded(true));
  };

  const processedRows = React.useMemo(() => {
    const newRows = rawRows.map((row) => ({
      ...row,
      id: row.ptsPlaceID + ' ' + row.PlaceID,
    }));

    const merged = [...selectedRowsData, ...newRows];

    return Array.from(new Map(merged.map((r) => [r.id, r])).values());
  }, [rawRows, selectedRowsData]);

  const normalizeSelection = (payload) => {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.selectionModel)) return payload.selectionModel;
    return [];
  };

  const handleSelectChange = (payload) => {
    const sel = normalizeSelection(payload);
    setSelectedIDs(sel);
    const selected = processedRows.filter((r) => sel.includes(r.id));
    setSelectedRowsData(selected);
    const sourceIds = selected.map((r) => r.ptsPlaceID);
    setSourceID(sourceIds);
    props.setRows((prevRows) => {
      const existingIdSet = new Set(prevRows.map((r) => r.ptsPlaceID));
      const missingRows = selected.filter((s) => !existingIdSet.has(s.ptsPlaceID));
      return [...prevRows, ...missingRows];
    });
  };

  return (
    <>
      <QuickSearch search={search} loaded={loaded} />

      <div style={{ height: 500 }}>
        <XGrid
          columns={columns}
          rows={processedRows}
          checkboxSelection
          selectionModel={selectedIDs}
          onSelectionModelChange={handleSelectChange}
        />
      </div>
    </>
  );
}

export default SelectTarget;
